// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__11dsp","alertIcon":"ConfirmModal_alertIcon__v_aUc"};